module.exports = __webpack_public_path__ + "img/logo-nxrlzy.938bbadc.png";